import type { CustomerRatingsConfig } from './customerRatings.types';

export const customerRatingsConfig: CustomerRatingsConfig = {
  ratingButtonEnabled: true,
  forceEnableRatingButtonParam: null,
  verifiedRatingsLayerURL: '/fragment/inspire/servicelayer/<language>/<layerid>',
  termsId: 'hint_nutzungsbedingungen_kdbeweformular',
  pagingCount: 20,
  maxRating: 5,
};
